import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { EUINumericField } from '../EUI/EUINumericField';

export class EUICurrencyField extends Component {

    static defaultProps = {
        scale: 3,
        value: "",
    };

    static defaultState = {
        hasFocus: false,
    };

    constructor() {
        super();
        this.state = { ...EUICurrencyField.defaultState };
    };

    _onBlur = (event, newValue) => {
        const { onBlur } = this.props;
        this.setState({ hasFocus: false });
        if (typeof onBlur === "function") onBlur(event, newValue);
    };

    _onFocus = (event) => {
        const { onFocus } = this.props;
        this.setState({ hasFocus: true });
        if (typeof onFocus === "function") onFocus(event);
    };

    render = () => {

        const { scale, value } = this.props;
        const { hasFocus } = this.state;
        
        return <EUINumericField
            {...this.props}
            onBlur={this._onBlur}
            onFocus={this._onFocus}
            suffix="€"
            type={hasFocus ? "number" : "text"}
            value={hasFocus ? value : Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(value, true, scale)}
        />;

    };

};